<div *ngIf="isLoading | async" class="overlay">
    <div>
        <mat-progress-spinner class="spinner" [color]="color" [mode]="mode" [value]="value"></mat-progress-spinner>
    </div>
</div>
